import React, { useState } from "react";
import { Dropdown } from "antd";
import {
  LogoutOutlined,
  MessageOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeaderAvatar from "./HeaderAvatar";

function getUserFromStorage() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
}

function getDisplayName(user) {
  const name = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  return name || user.emailAddress || "User";
}

function getInitial(user) {
  const name = getDisplayName(user);
  return (name[0] || "U").toUpperCase();
}

export default function UserProfileMenu({ onLogout }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const user = getUserFromStorage();
  const displayName = getDisplayName(user);
  const email = user.emailAddress || "";
  const initial = getInitial(user);

  const goTo = (path) => {
    setOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    setOpen(false);
    onLogout();
  };

  const menu = (
    <div className="app-header-user-menu">
      <div className="app-header-user-menu-profile">
        <HeaderAvatar
          initial={initial}
          size={48}
          className="app-header-user-menu-avatar"
        />
        <div className="app-header-user-menu-name">{displayName}</div>
        {email ? (
          <div className="app-header-user-menu-email">{email}</div>
        ) : null}
      </div>
      <div className="app-header-user-menu-actions">
        <button
          type="button"
          className="app-header-user-menu-item"
          onClick={() => goTo("/app/settings?tab=profile")}
        >
          <UserOutlined />
          Profile settings
        </button>
        <button
          type="button"
          className="app-header-user-menu-item"
          onClick={() => goTo("/app/settings?tab=support")}
        >
          <MessageOutlined />
          Send feedback
        </button>
      </div>
      <div className="app-header-user-menu-footer">
        <button
          type="button"
          className="app-header-user-menu-item app-header-user-menu-logout"
          onClick={handleLogout}
        >
          <LogoutOutlined />
          Log out
        </button>
      </div>
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      placement="bottomRight"
      dropdownRender={() => menu}
    >
      <button
        type="button"
        className="app-header-icon-btn app-header-avatar-btn"
        aria-label="Open profile menu"
      >
        <HeaderAvatar initial={initial} size={32} />
      </button>
    </Dropdown>
  );
}
